import presetReact from "@bbob/preset-react";
import BBCode from "@bbob/react";
import React from "react";

const plugins = [presetReact()];

export function TicketNotice({ notice }: { notice: string }) {
  return (
    <div className="w-full text-[12px] whitespace-break-spaces">
      <BBCode plugins={plugins}>{notice}</BBCode>
    </div>
  );
}
